import React from 'react'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap'

const Confirmation = ({ isOpen, toggle, className, title, text, confirm, confirm_text, cancel, cancel_text }) => {
    return (
        <Modal isOpen={isOpen} toggle={toggle} className={className || undefined} autoFocus={false}>
          { title && <ModalHeader toggle={toggle}>{title}</ModalHeader> || null }
          <ModalBody>
            { text || 'Are you sure?' }
          </ModalBody>
          <ModalFooter>
            <Button color="danger" onClick={() => { (confirm && confirm()); toggle(); }} autoFocus={true}>{confirm_text || 'Yes'}</Button>{' '}
            <Button color="secondary" onClick={() => { (cancel && cancel()); toggle(); }}>{ cancel_text || 'Cancel' }</Button>
          </ModalFooter>
        </Modal>
    )
}

export default Confirmation
